import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ApiError, MessageService, ButtonLoader } from '../../../../core';
import { Cidade, CidadeCrudHttpService, CidadeFilter } from '../../../cidade';
import { Estado, EstadoCrudHttpService } from '../../../estado';
import { RegiaoGeograficaIntermediaria, RegiaoGeograficaIntermediariaFilter, RegiaoGeograficaIntermediariaCrudHttpService } from '../../../regiao-geografica/intermediaria';
import { RegiaoGeograficaImediata, RegiaoGeograficaImediataFilter, RegiaoGeograficaImediataCrudHttpService } from '../../../regiao-geografica/imediata';
import { RegiaoCidade } from '../regiao-cidade';
import { RegiaoCidadePopula } from './regiao-cidade-popula';

@Component({
    selector: 'sgt-regiao-cidade-popula-modal',
    templateUrl: './regiao-cidade-popula-modal.component.html',
    styleUrls: ['./regiao-cidade-popula-modal.component.less']
})
export class RegiaoCidadePopulaModalComponent implements OnInit {
    @Input() entities: RegiaoCidade[];
    @Input() idModal: string | 'regiaoCidadePopulaModal';
    elModal: any;

    @ViewChild('form') form: NgForm;
    filter = new CidadeFilter();
    estados: Estado[] = [];
    regioesIntermediarias: RegiaoGeograficaIntermediaria[] = [];
    regioesImediatas: RegiaoGeograficaImediata[] = [];
    popula: RegiaoCidadePopula[] = [];
    allCidadesSelected: boolean;

    constructor(private el: ElementRef,
                private messageService: MessageService,
                private estadoCrudHttpService: EstadoCrudHttpService,
                private regiaoGeograficaIntermediariaCrudHttpService: RegiaoGeograficaIntermediariaCrudHttpService,
                private regiaoGeograficaImediataCrudHttpService: RegiaoGeograficaImediataCrudHttpService,
                private cidadeCrudHttpService: CidadeCrudHttpService) { }

    ngOnInit() {
        this.create();

        this.searchEstados();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                jQuery(this.elModal).find('#filterEstado').trigger('focus');
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    private clear() {
        // this.form.resetForm();
        this.filter.clear();
        this.popula = [];
    }

    open() {
        this.clear();
        this.elModal.modal({keyboard: false, backdrop: 'static'});
    }

    close() {
        this.elModal.modal('hide');
    }

    /** Pesquia os estados */
    private searchEstados() {
        this.estados = [];
        this.estadoCrudHttpService.search()
            .subscribe(
                entities => this.estados = entities,
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar os estados', error)
            );
    }

    /** Ao alterar o estado */
    onChangeEstado(idEstado: number) {
        this.clearRegiaoIntermediaria();

        if (idEstado) {
            this.filter.idEstado = idEstado;
            this.searchRegioesIntermediarias();
        } else {
            this.clearEstado();
        }
    }

    /** Limpa os dados do estado */
    private clearEstado() {
        this.filter.idEstado = null;
        this.clearRegiaoIntermediaria();
    }

    /** Pesquisa as regiões geográficas intermediárias do estado selecionado */
    private searchRegioesIntermediarias() {
        this.regioesIntermediarias = [];
        const filterRegiaoIntermediaria = new RegiaoGeograficaIntermediariaFilter();
        filterRegiaoIntermediaria.idEstado = this.filter.idEstado;
        this.regiaoGeograficaIntermediariaCrudHttpService.searchWithFilter(filterRegiaoIntermediaria)
            .subscribe(
                entities => this.regioesIntermediarias = entities,
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar as regiões intermediárias do estado selecionado', error)
            );
    }

    /** Ao alterar a região geográfica intermediária */
    onChangeRegiaoIntermediaria(idRegiaoGeograficaIntermediaria: number) {
        this.clearRegiaoImediata();

        if (idRegiaoGeograficaIntermediaria) {
            this.filter.idRegiaoGeograficaIntermediaria = idRegiaoGeograficaIntermediaria;
            this.searchRegioesImediatas();
        } else {
            this.filter.idRegiaoGeograficaIntermediaria = null;
        }
    }

    /** Limpa os dados da região geográfica intermediária */
    private clearRegiaoIntermediaria() {
        this.filter.idRegiaoGeograficaIntermediaria = null;
        this.regioesIntermediarias = [];
        this.clearRegiaoImediata();
    }

    /** Pesquisa as regiões geográficas imediatas da região geográfica intermediária selecionada */
    private searchRegioesImediatas() {
        this.regioesImediatas = [];
        const filterRegiaoImediata = new RegiaoGeograficaImediataFilter();
        filterRegiaoImediata.idRegiaoGeograficaIntermediaria = this.filter.idRegiaoGeograficaIntermediaria;
        this.regiaoGeograficaImediataCrudHttpService.searchWithFilter(filterRegiaoImediata)
            .subscribe(
                entities => this.regioesImediatas = entities,
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar as regiões imediatas da região intermediária selecionada', error)
            );
    }

    /** Limpa os dados da região geográfica imediata */
    private clearRegiaoImediata() {
        this.filter.idRegiaoGeograficaImediata = null;
        this.regioesImediatas = [];
    }

    /** Pesquisa as cidades */
    searchCidades() {
        if (!this.filter.idEstado) {
            this.messageService.info('É necessário selecionar o estado para pesquisar as cidades', 'Informação');
            return;
        }

        const btnSearchCidades = new ButtonLoader('#btnSearchCidades');
        btnSearchCidades.loading('Pesquisando');
        this.popula = [];
        this.cidadeCrudHttpService.searchWithFilter(this.filter, null, null, null, 2, 'asc')
            .subscribe(
                response => {
                    this.createPopula(response.data);
                    btnSearchCidades.reset();
                },
                (error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao pesquisar as cidades', error);
                    btnSearchCidades.reset();
                }
            )
    }

    /** Cria a listagem das cidades para serem adicionadas na região */
    private createPopula(cidades: Cidade[]) {
        this.popula = [];
        if (!cidades) {
            return;
        }

        cidades.forEach(cidade => {
            const entityPopula = new RegiaoCidadePopula();
            entityPopula.selected = true;

            let entity = this.getRegiaoCidade(cidade);
            if (entity) {
                entityPopula.exist = true;
            } else {
                entity = new RegiaoCidade();
                entity.idCidade = cidade.id;
                entity.cidade = cidade;
            }
            entityPopula.regiaoCidade = entity;

            this.popula.push(entityPopula);
        });

        this.allCidadesSelected = true;
    }

    /** Tenta obter a cidade dentro das cidades já adicionadas na região*/
    private getRegiaoCidade(cidade: Cidade): RegiaoCidade {
        if (!cidade || !this.entities) {
            return null;
        }

        for (let i = 0; i < this.entities.length; i++) {
            const entity = this.entities[i];
            if (entity.idCidade === cidade.id) {
                return entity;
            }
        }
        return null;
    }

    /** Ao alterar a opção de selecionar todas as cidades listadas */
    onChangeAllCidadesSelected(value: boolean) {
        if (!this.popula) {
            return;
        }

        this.popula.forEach(entityPopula => {
            if (!entityPopula.exist) {
                entityPopula.selected = value;
            }
        });
    }

    /** Ao alterar o checkbox de um cidade específica verificamos se todas estão selecionadas */
    onChangeCidadeSelected() {
        let allSelected = true;
        for (let i = 0; i < this.popula.length; i++) {
            const entityPopula = this.popula[i];
            if (!entityPopula.selected) {
                allSelected = false;
                break;
            }
        }
        this.allCidadesSelected = allSelected;
    }

    /** Verifica se possui alguma cidade selecionada */
    private possuiAlgumaCidadeSelecionada(): boolean {
        if (!this.popula) {
            return false;
        }

        for (let i = 0; i < this.popula.length; i++) {
            const entityPopula = this.popula[i];
            if (entityPopula.selected && !entityPopula.exist) {
                return true;
            }
        }

        return false;
    }


    /** Adiciona as cidades selecionadas e que ainda não estão adicionas à região */
    adicionar() {
        if (!this.possuiAlgumaCidadeSelecionada()) {
            this.messageService.info('Selecione pelo menos uma cidade para adicionar na região ou clique em cancelar se não desejar adicionar nenhuma cidade', 'Informação');
            return;
        }

        const btnAdicionar = new ButtonLoader('#btnAdicionar');
        btnAdicionar.loading('Adicionando');
        this.popula.forEach(entityPopula => {
            if (entityPopula.selected && !entityPopula.exist) {
                this.entities.push(entityPopula.regiaoCidade);
            }
        });

        btnAdicionar.reset();
        this.close();
    }
}
